module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/ja-联系我们banner.4e6142a4.png";